
import React from "react";
import { Form } from "react-final-form";
import { useAuthenticated } from "react-admin";
import AppBar from "../../../Components/header/index";
import MentorProfile from "../../../Screens/MentorProfile/Components/mentorProfile"
import ScheduleAppointmentForm3 from "../../../Screens/ScheduleAppointment/Components/scheduleAppointment3"
import AppProvider from "../../../Components/bootstrap"
import { useAuthProvider } from "react-admin";
import { useAppointment } from "../hooks"
// import { selectMentor } from "../actions";
import Parse from './../../../Utils/index'
const ScheduleAppointment3 = props => {
  useAuthProvider();
  const { selectAttendees } = useAppointment()
  // const redirect = useRedirect();
  useAuthenticated()

  return (
    <div style={{ zoom: "88%" }}>
      <AppProvider>
        <AppBar />
        <MentorProfile typography="Home / Mentor Profile / Schedule Appointment" />
        <div >
          <Form
            initialValues={{
              // isMentor
            }}
            onSubmit={async response => {
              console.log(response)
              let selectedAttendeesData = response.manyAttendees ? response.selectedAttendees.map(selectedAttendee => selectedAttendee.id) : []
              selectedAttendeesData.push(Parse.User.current().toJSON().objectId)
              console.log(selectedAttendeesData)
              selectAttendees(selectedAttendeesData)
            }}
            keepDirtyOnReinitialize
            render={ScheduleAppointmentForm3}
          />
        </div>
      </AppProvider>
    </div>
  );
};
export default ScheduleAppointment3;
